module.exports = __webpack_public_path__ + "img/at.b8509425.svg";